import React, { useState, useEffect } from 'react';
import { API_BASE } from '../lib/config';

const API = API_BASE;

const DebugTest = () => {
  const [testResults, setTestResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [jobSeekerEmail, setJobSeekerEmail] = useState('debug_jobseeker@example.com');
  const [employerEmail, setEmployerEmail] = useState('debug_employer@example.com');
  const [password, setPassword] = useState('password123');
  const [currentUser, setCurrentUser] = useState(null);

  const runTests = async () => {
    setLoading(true);
    const results = [];

    // Test 1: Health check
    try {
      const response = await fetch(`${API}/health`);
      const data = await response.json();
      results.push({
        test: 'Health Check',
        status: response.ok ? 'PASS' : 'FAIL',
        result: data
      });
    } catch (error) {
      results.push({
        test: 'Health Check',
        status: 'ERROR',
        result: error.message
      });
    }

    // Test 2: API Health check
    try {
      const response = await fetch(`${API_BASE}/health`);
      const data = await response.json();
      results.push({
        test: 'API Health Check',
        status: response.ok ? 'PASS' : 'FAIL',
        result: data
      });
    } catch (error) {
      results.push({
        test: 'API Health Check',
        status: 'ERROR',
        result: error.message
      });
    }

    // Test 3: Banners endpoint
    try {
      const response = await fetch(`${API_BASE}/banners`);
      const data = await response.json();
      results.push({
        test: 'Banners API',
        status: response.ok ? 'PASS' : 'FAIL',
        result: data
      });
    } catch (error) {
      results.push({
        test: 'Banners API',
        status: 'ERROR',
        result: error.message
      });
    }

    // Test 4: Categories endpoint
    try {
      const response = await fetch(`${API_BASE}/categories`);
      const data = await response.json();
      results.push({
        test: 'Categories API',
        status: response.ok ? 'PASS' : 'FAIL',
        result: data
      });
    } catch (error) {
      results.push({
        test: 'Categories API',
        status: 'ERROR',
        result: error.message
      });
    }

    setTestResults(results);
    setLoading(false);
  };

  const refreshCurrentUser = async () => {
    try {
      const token = localStorage.getItem('token');
      if (!token) { setCurrentUser(null); return; }
      const res = await fetch(`${API_BASE}/auth/me`, { headers: { Authorization: `Bearer ${token}` } });
      if (res.ok) {
        const data = await res.json();
        setCurrentUser(data);
      } else {
        setCurrentUser(null);
      }
    } catch {
      setCurrentUser(null);
    }
  };

  useEffect(() => {
    runTests();
    refreshCurrentUser();
  }, []);

  const quickSignupAndLogin = async (userType, email) => {
    try {
      const res = await fetch(`${API_BASE}/auth/register`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password, user_type: userType }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data?.detail || 'failed');
      if (data?.access_token && data?.user) {
        localStorage.setItem('token', data.access_token);
        localStorage.setItem('user', JSON.stringify(data.user));
        await refreshCurrentUser();
        // 目的ページへジャンプ
        const dest = userType === 'employer' ? '/business/dashboard' : '/mypage';
        window.location.assign(dest);
      } else {
        alert('即時ログインレスポンスではありません。メール確認が必要な構成かもしれません。');
      }
    } catch (e) {
      alert(`Quick signup/login failed: ${e?.message || e}`);
    }
  };

  return (
    <div className="p-4 bg-gray-100 min-h-screen">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-2xl font-bold mb-4">Debug Test Page</h1>
  <p className="mb-1">Backend URL: {API}</p>
  <p className="mb-4">API Base: {API_BASE}</p>
        
        <button 
          onClick={runTests}
          disabled={loading}
          className="bg-blue-500 text-white px-4 py-2 rounded mb-4 disabled:bg-gray-400"
        >
          {loading ? 'Running Tests...' : 'Run Tests'}
        </button>

  <div className="space-y-4">
          {testResults.map((result, index) => (
            <div key={index} className="bg-white p-4 rounded shadow">
              <div className="flex items-center mb-2">
                <span className="font-semibold mr-2">{result.test}:</span>
                <span className={`px-2 py-1 rounded text-sm ${
                  result.status === 'PASS' ? 'bg-green-100 text-green-800' :
                  result.status === 'FAIL' ? 'bg-red-100 text-red-800' :
                  'bg-yellow-100 text-yellow-800'
                }`}>
                  {result.status}
                </span>
              </div>
              <pre className="bg-gray-100 p-2 rounded text-sm overflow-auto">
                {JSON.stringify(result.result, null, 2)}
              </pre>
            </div>
          ))}
        </div>

        <div className="mt-8 bg-white p-4 rounded shadow">
          <h2 className="text-lg font-semibold mb-2">Quick Signup & Login (Email Verify Skipped)</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm text-gray-700 mb-1">Job Seeker Email</label>
              <input className="border px-2 py-1 rounded w-full" value={jobSeekerEmail} onChange={(e)=>setJobSeekerEmail(e.target.value)} />
            </div>
            <div>
              <label className="block text-sm text-gray-700 mb-1">Employer Email</label>
              <input className="border px-2 py-1 rounded w-full" value={employerEmail} onChange={(e)=>setEmployerEmail(e.target.value)} />
            </div>
            <div>
              <label className="block text-sm text-gray-700 mb-1">Password</label>
              <input className="border px-2 py-1 rounded w-full" value={password} onChange={(e)=>setPassword(e.target.value)} type="password" />
            </div>
          </div>
          <div className="mt-3 flex gap-2">
            <button onClick={()=>quickSignupAndLogin('job_seeker', jobSeekerEmail)} className="bg-green-600 text-white px-3 py-2 rounded">Create & Login (Job Seeker)</button>
            <button onClick={()=>quickSignupAndLogin('employer', employerEmail)} className="bg-purple-600 text-white px-3 py-2 rounded">Create & Login (Employer)</button>
          </div>

          <div className="mt-4">
            <h3 className="font-medium mb-1">Current User</h3>
            <pre className="bg-gray-100 p-2 rounded text-sm overflow-auto">{JSON.stringify(currentUser, null, 2)}</pre>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DebugTest;